import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API_CONSTANT } from '../../services/api.constant';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.scss']
})
export class CustomerRequestComponent implements OnInit {
  language = localStorage.getItem('lang') || 'en';
  refreshDropdown = false;
  modal: NgbModalRef;
  countries: any[];
  confirmLoading: boolean = false;
  buyerRequestForm: FormGroup;
  showError: boolean = false;
  loading: boolean = false;
  plusKeyPressed: boolean = false;
  isThailand: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private modalService: NgbModal,
  ) {
    if (!environment.enabledCustomerRequest) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe(() => {
      this.translateDropdown();
    });
    this.createBuyerRequestForm();
    this.loadCountries();
  }

  translateDropdown(): void {
    this.refreshDropdown = true;
    setTimeout(() => {
      this.refreshDropdown = false;
    }, 1);
  }

  changeLanguage() {
    this.translate.use(this.language);
    localStorage.setItem('lang', this.language);
  }

  handleDocTypeButton(): void {
    this.form.abbNo01.setValue(null);
    this.form.abbNo02.setValue(null);
    this.form.abbNo03.setValue(null);
    this.form.billingNo.setValue(null);
    this.showError = false;
  }

  get invalidAbbNo(): boolean {
    return (
      (this.form.abbNo01.errors && this.form.abbNo01.errors.required) ||
      (this.form.abbNo02.errors && this.form.abbNo02.errors.required) ||
      (this.form.abbNo03.errors && this.form.abbNo03.errors.required)
    );
  }

  createBuyerRequestForm() {
    this.buyerRequestForm = this.formBuilder.group({
      type: ['hotel', Validators.required],
      abbNo01: [null, Validators.required],
      abbNo02: [null, Validators.required],
      abbNo03: [null, Validators.required],
      billingNo: [null],
      name: [null, Validators.required],
      taxID: [null, [this.validateTaxId, Validators.required]],
      branchCode: [null],
      branchName: [null],
      address: [null, Validators.required],
      subDistrict: [null, Validators.required],
      district: [null, Validators.required],
      province: [null, Validators.required],
      postcode: [null, this.validatePostCode],
      country: [221, Validators.required],
      email: [null, [this.validateEmail, Validators.required]],
      ccEmail: [null],
      phoneNumber: [null, [Validators.required]]
    });
  }

  documentRequestSpaType(): boolean {
    return this.form.type.value === 'spa';
  }

  validateTaxId(control: AbstractControl) {
    if (
      control.value && Boolean(control.value.match(/^[0-9]{13}$/g))
    ) {
      return null;
    }
    return { taxIDInvalid: true };
  }

  validateEmail(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      return Validators.email(control);
    }
    return null;
  }

  validatePostCode(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
      return null;
    }
    return {'postalCodeInvalid': true};
  }

  loadCountries() {
    this.httpClient.get(API_CONSTANT.country).subscribe(
      (res: any) => {
        this.countries = res;
      }
    );
  }

  get countryCode(): string {
    return this.form.country.value;
  }

  countryChange(event) {
    if (event.country_code === 'TH') {
      this.isThailand = true;
      this.form.postcode.setValidators([this.validatePostCode]);
      this.form.taxID.setValidators([this.validateTaxId, Validators.required]);
    } else {
      this.isThailand = false;
      this.form.postcode.setValidators([]);
      this.form.taxID.clearValidators();
    }
    this.form.postcode.updateValueAndValidity();
    this.form.taxID.updateValueAndValidity();
  }

  alertSubmitSuccess() {
    Swal.fire({
      title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-SUCCESS'),
      html: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-SUCCESS'),
      type: 'success',
      confirmButtonColor: '#02008a',
      confirmButtonText: this.translate.instant('COMMON.CLOSE'),
      customClass: {
        title: 'custom-title'
      },
      width: '600px'
    });
  }

  alertSubmitFailure() {
    Swal.fire({
      title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-FAILED'),
      text: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-FAILED'),
      type: 'error',
      confirmButtonColor: '#02008a',
      confirmButtonText: this.translate.instant('COMMON.CLOSE'),
      customClass: {
        title: 'text-red'
      }
    });
  }

  formatPhoneNumber(event: any): void {
    const valueInput = event.target.value;
    const checkPlus = valueInput.includes('+');
    if (checkPlus) {
      const textValue = valueInput.replace('+', '');
      event.target.value = '+' + textValue;
      this.cdRef.detectChanges();
    } else {
      this.plusKeyPressed = false;
    }

  }

  charValidate(event: any): boolean {
    if ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 43 && !this.plusKeyPressed)) {
      if (event.charCode === 43) {
        this.plusKeyPressed = true;
      }
      return true;
    }
    return false;
  }

  onSubmit(content) {
    this.handleValidatorDocumentSpaType();
    this.showError = false;
    if (this.buyerRequestForm.invalid) {
      this.showError = true;
      return;
    }
    this.modal = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg'
    });
  }

  handleValidatorDocumentSpaType(): void {
  const areValidatorsRequired = !this.documentRequestSpaType();

  if (areValidatorsRequired) {
    this.setValidatorsForAbbNos([Validators.required]);
  } else {
    this.clearValidatorsForAbbNos();
  }

  this.updateAbbNosValidity();
  }

  private setValidatorsForAbbNos(validators: ValidatorFn[]): void {
    this.form.abbNo01.setValidators(validators);
    this.form.abbNo02.setValidators(validators);
    this.form.abbNo03.setValidators(validators);
  }

  private clearValidatorsForAbbNos(): void {
    this.form.abbNo01.clearValidators();
    this.form.abbNo02.clearValidators();
    this.form.abbNo03.clearValidators();
  }

  private updateAbbNosValidity(): void {
    this.form.abbNo01.updateValueAndValidity();
    this.form.abbNo02.updateValueAndValidity();
    this.form.abbNo03.updateValueAndValidity();
  }

  closePopup() {
    this.modal.close();
  }

  submit() {
    this.loading = true;
    const data = {
      room_type: this.form.type.value,
      confirmation_no: '',
      abb_no: this.documentRequestSpaType() ?
        this.form.billingNo.value : `${this.form.abbNo01.value}-${this.form.abbNo02.value}-${this.form.abbNo03.value}`,
      buyer_name: this.form.name.value,
      tax_id: this.form.taxID.value,
      branch_code: this.form.branchCode.value,
      branch_name: this.form.branchName.value,
      address: `${this.form.address.value} ${this.form.subDistrict.value} ${this.form.district.value} ${this.form.province.value}`,
      postal_code: this.form.postcode.value,
      country: this.form.country.value,
      email: this.form.email.value,
      cc_email: this.form.ccEmail.value,
      phone_number: this.form.phoneNumber.value,
    };
    this.httpClient.post(API_CONSTANT.document_request, data)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.showError = false;
        })
      )
      .subscribe(
        () => {
          this.buyerRequestForm.reset();
          this.form.type.setValue('hotel');
          this.closePopup();
          this.alertSubmitSuccess();
        },
        () => {
          this.alertSubmitFailure();
        }
      );
  }

  taxIDChange(event: any): void {
    const taxID = event.target.value;
    if (!taxID || taxID.length !== 13) {
      return;
    }
    const params = {
      tax_id: taxID
    };
    this.httpClient.get(`${API_CONSTANT.buyer}external/`, {params: params}).subscribe(
      (result) => {
        this.buyerRequestForm.patchValue({
          name: result['name'],
          address: result['address'],
          country: result['country_id'],
          postcode: result['post_code'],
        });
        this.form.postcode.setValidators([this.validatePostCode]);
        this.form.postcode.updateValueAndValidity();
      },
    );
  }

  get form(): { [key: string]: AbstractControl } {
    return this.buyerRequestForm.controls;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.ts